import { RiLoader4Fill } from "react-icons/ri";
import './loader.css'
const Loder = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center w-100"
      style={{ height: "200px" }}
    >
      <RiLoader4Fill className="spinner" style={{ fontSize: "50px" }} />
    </div>
  );
};

export default Loder;
